export default function* removeWidgetSaga(getFirebase, action) {
  const { payload: { projectId, widgetId } } = action;
  try {
    yield getFirebase().remove(`/projects/${projectId}/map/widgets/${widgetId}`);
  } catch (err) {
    console.log('Error in saga!:', err);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/map/RemoveWidgetSaga.js